import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

interface Props {
  modelValue: boolean
  isLoading?: boolean
}

interface Emits {
  (e: 'modelValue', value: boolean): void
  (e: 'confirm'): void
  (e: 'cancel'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPayByCheck',
  props: {
    modelValue: { type: Boolean },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["modelValue", "confirm", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'modelValue', value: boolean): void
  (e: 'confirm'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, isLoading: boolean }





const isVisible = ref(props.modelValue)
const modalRef = ref<HTMLElement | null>(null)

onMounted(() => {
  if (modalRef.value && modalRef.value.parentNode !== document.body) {
    document.body.appendChild(modalRef.value)
  }
})

onBeforeUnmount(() => {
  if (modalRef.value?.parentNode) {
    modalRef.value.parentNode.removeChild(modalRef.value)
  }
})

watch(() => props.modelValue, (newValue) => {
  isVisible.value = newValue
})

watch(isVisible, (newValue) => {
  if (newValue !== props.modelValue) {
    emit('modelValue', newValue)
  }
})

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  isVisible.value = false
  emit('cancel')
}

return { __sfc: true,props, emit, isVisible, modalRef, handleConfirm, handleCancel }
}

})